module.exports = __webpack_public_path__ + "img/bg-video-1.fdb3d9a8.png";